import React from 'react';
import packagejson from '../../package.json'
import { Container } from '../components';
import { DefaultLayout } from '../layouts';

const last_updated_at = '2021-06-08 11:36:05'
const version_tag = '2021JUNE'
const message = undefined
// const message = 'Semantic Versioning is currently disabled.'
// const message = 'Current version is prepared for event flow.'

const Version = () => {
  return (
    <DefaultLayout>
      <Container className="text-center py-20">
        <div style={{minHeight: '30vh'}}>
          {
            message &&
            <p className="mb-4">{message}</p>
          }
          <ul>
            <li>Version: {version_tag} {packagejson.version}</li>
            <li>Last updated at: {last_updated_at}</li>
          </ul>
        </div>
      </Container>
    </DefaultLayout>
  )
}

export { Version }
